module.exports = __webpack_public_path__ + "static/media/pdf.19b25c43.svg";